import { useDrop } from 'react-dnd';
import { ItemTypes } from '../types/columnNames';

export const useDndSideBar = (groupId: string) => {
  const [{ canDrop, isOver }, drop] = useDrop(
    () => ({
      accept: ItemTypes.BOX,
      drop: () => ({
        id: `${groupId}`,
      }),
      collect: (monitor: any) => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
    }),
    []
  );

  return {
    canDrop,
    isOver,
    drop,
  };
};
